import axios from "axios";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import deepCopy from "../../../../utils/deepcopy.js";
import "./index.css";
import EnhancedTable from "../../components/EnhancedTable.jsx";
import {
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import { updateAdminProjects, updateAlert } from "../../redux/actions.js";

function ProjectPanel(props) {
  const [projects, setProjects] = useState([]);
  const [projectOpen, setProjectOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState({});
  const [projectReload, setProjectReload] = useState(false);
  const [searchProjects, setSearchProjects] = useState([]);

  // ---------- project info ----------
  const [projectReject, setProjectReject] = useState(false);
  const [projectRejectReason, setProjectRejectReason] = useState("");

  const projectHeadCells = [
    {
      id: "id",
      numeric: true,
      disablePadding: true,
      label: "ProjectId",
      align: "center",
    },
    {
      id: "name",
      numeric: false,
      disablePadding: false,
      label: "Name",
      align: "left",
    },
    {
      id: "title",
      numeric: false,
      disablePadding: false,
      label: "Title",
      align: "left",
    },
    {
      id: "description",
      numeric: false,
      disablePadding: false,
      label: "Description",
      align: "left",
    },
    {
      id: "goal",
      numeric: false,
      disablePadding: false,
      label: "Goal",
      align: "left",
    },
    {
      id: "usernames",
      numeric: false,
      disablePadding: false,
      label: "Usernames",
      align: "left",
    },
    {
      id: "approveStatus",
      numeric: false,
      disablePadding: false,
      label: "Status",
      align: "center"
    }
  ];

  useEffect(() => {
    if (props.projects === null || projectReload) {
      axios({
        method: "post",
        url: "/api/m2d/admin/getAllProjects",
        data: {
          adminId: props.user.id
        }
      }).then(res => {
        const new_projects = deepCopy(res.data)
        new_projects.map(project => {
          const usernames = project.users.map(user => `${user.firstName} ${user.lastName}`)
          project.usernames = `${usernames[0]}${usernames.length > 1 ? ` and ${usernames.length - 1} others` : ''}`
          return project
        })
        setProjects(new_projects)
        props.handleProjects(new_projects)
        setProjectReload(false)
      })
    } else {
      setProjects(props.projects)
    }
  }, [projectReload, props])

  // ---------- project functions ----------

  const handleClearProjectSearch = () => {
    setSearchProjects([])
  };

  const handleProjectSearch = (name) => {
    setSearchProjects(projects.filter(project => project.name.includes(name) || project.title.includes(name)))
  }

  const handleProjectEdit = (selected) => {
    setSelectedProject(selected)
    setProjectOpen(true)
  }

  const handleProjectClose = () => {
    setProjectOpen(false)
  }

  const handleProjectApprove = () => {
    if (selectedProject.id !== undefined) {
      axios({
        method: "post",
        url: "/api/m2d/admin/approveProject",
        data: {
          adminId: props.user.id,
          pid: selectedProject.id
        }
      }).then(() => {
        setProjectOpen(false)
        setProjectReload(!projectReload)
        props.handleAlert("success", "Successfully approved!")
      }).catch(err => {
        console.log(err)
        props.handleAlert("error", err.message)
      })
    }
  }

  const handleProjectReject = () => {
    if (!projectReject || !projectRejectReason) {
      setProjectReject(true)
    } else {
      // handle reject
      if (selectedProject.id !== undefined) {
        axios({
          method: "post",
          url: "/api/m2d/admin/rejectProject",
          data: {
            adminId: props.user.id,
            pid: selectedProject.id,
            rejectReason: projectRejectReason
          }
        }).then(() => {
          setProjectOpen(false)
          setProjectReject(false)
          setProjectRejectReason("")
          setSelectedProject({})
          setProjectReload(!projectReload)
          props.handleAlert("success", "Successfully rejected!")
        }).catch(err => {
          console.log(err)
          props.handleAlert("error", err.message)
        })
      }
    }
  }

  const handleProjectCancel = () => {
    if (!projectReject) {
      handleProjectClose()
    } else {
      setProjectReject(false)
      setProjectRejectReason("")
    }
  }

  const handleProjectRejectReasonChange = (e) => {
    setProjectRejectReason(e.target.value)
  }

  return (
    <>
      <EnhancedTable
        title="Projects"
        headCells={projectHeadCells}
        rows={searchProjects.length > 0 ? searchProjects : projects}
        handleEdit={handleProjectEdit}
        handleSearch={handleProjectSearch}
        handleClearSearch={handleClearProjectSearch}
        search="Search by name"
      />

      {/* ---------- edit project ---------- */}
      <Dialog open={projectOpen} onClose={handleProjectClose} >
        <DialogTitle>{selectedProject.name}</DialogTitle>
        <DialogContent sx={{ minWidth: '500px' }}>
          <DialogContentText>
            <b>Title:</b> {selectedProject.title}
          </DialogContentText>
          <DialogContentText>
            <b>Description:</b> {selectedProject.description}
          </DialogContentText>

          <DialogContentText>
            <b>Goal:</b> {selectedProject.goal}
          </DialogContentText>
          <DialogContentText>
            <b>User{selectedProject.users && selectedProject.users.length > 1 ? 's' : ''}:</b> {selectedProject.users ? selectedProject.users.map((user) => {
              return (
                <span key={user.id}>{user.firstName} {user.lastName} ({user.email}) </span>
              )
            }) : ''}
          </DialogContentText>

          {projectReject ? (
            <TextField
              margin="normal"
              id="name"
              label="Reject reason"
              type="username"
              fullWidth
              variant="outlined"
              value={projectRejectReason}
              multiline
              maxRows={5}
              onChange={handleProjectRejectReasonChange}
            />
          ) : null}

        </DialogContent>
        <DialogActions sx={{ marginRight: "15px", marginBottom: "10px" }}>
          <Button variant="outlined" onClick={handleProjectCancel}>Cancel</Button>
          <Button variant="outlined" color="error" onClick={handleProjectReject}>Reject</Button>
          {projectReject ? null : (
            <Button variant="contained" onClick={handleProjectApprove}>
              Approve
            </Button>
          )}

        </DialogActions>
      </Dialog>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    user: state.main.user,
    projects: state.m2d.adminProjects,
    role: state.m2d.role
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    handleAlert(alertType, alertMessage, time = 2500) {
      updateAlert(alertType, alertMessage, time)(dispatch);
    },

    handleProjects(projects) {
      updateAdminProjects(projects)(dispatch)
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ProjectPanel);
